import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import * as ROUTES from '../../constants/routes'

import Header from '../Header'
import Intro from '../Intro'
import Pricing from '../Pricing'
import ContactUs from '../ContactUs'
import Invoice from '../Invoice'
import Footer from '../Footer'
// import Dashboard from './components/Dashboard'

// import Tripi from '../Tripi'

class App extends React.Component {

    render() {

        // return <Tripi  size={600} />

        return (
            <div style={{ minheight: window.innerHeight, minWidth: '350px', textAlign: 'center', backgroundColor: 'rgb(190, 230, 255)', fontFamily: 'Ubuntu, sans-serif' }}>
                <BrowserRouter>
                    <div>
                        <Header />
                        <br /><br /><br /><br />
                        <Route exact path={ROUTES.HOME} component={Intro} />
                        <Route path={ROUTES.PRICING} component={Pricing} />
                        <Route path={ROUTES.CONTACTUS} component={ContactUs} />
                        <Route path={ROUTES.INVOICE} component={Invoice} />
                        <Footer />
                    </div>
                </BrowserRouter>
            </div>
        )

    }

}

export default App
